import styled from 'styled-components';
import { Box } from '../../layout/Box';

export const IconWrapper = styled(Box)
    .withConfig({ displayName: 'IconWrapper' })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        borderRadius: 1,
        background: props.background || 'none',
    }))``;
